// @flow
import React from 'react';
import DropdownLabel from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-label';
import DropdownSelect from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-select';
import DropdownButton from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-button';
import DropdownItem from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-item';
import styled from 'styled-components';
import type {DropdownOption} from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-option';
import type {Cryptocurrency} from '@tectonics/commons/cryptocurrency/cryptocurrencies/cryptocurrency-type';
import type {CryptocurrencyProtocol} from '@tectonics/commons/cryptocurrency/protocol/cryptocurrency-protocol-type';
import {translate} from '@tectonics/translate';

type Props = {
  selectedCryptocurrency: ?Cryptocurrency,
  selectedProtocolOption: DropdownOption,
  protocolIsOpen: boolean,
  setProtocolIsOpen: (boolean) => void,
  submitting: boolean,
  onProtocolSelect: (CryptocurrencyProtocol) => void,
};

const ProtocolDropdown = ({
  selectedCryptocurrency,
  selectedProtocolOption,
  protocolIsOpen,
  setProtocolIsOpen,
  submitting,
  onProtocolSelect,
}: Props) => (
  <>
    <DropdownLabel dataTestName="protocol">{translate('volcanes.payment-methods.cryptocurrency.networkLabel')}</DropdownLabel>
    <DropdownSelect dataTestName="protocol" setIsOpen={setProtocolIsOpen}>
      <InvisibleInputForTests
        type="select"
        id="protocol_dropdown"
        name="protocol_dropdown"
        value="protocol_dropdown"
        readOnly
      />
      <DropdownButton
        selectedOption={selectedProtocolOption}
        isOpen={protocolIsOpen}
        defaultText={translate('volcanes.payment-methods.cryptocurrency.networkSelectPlaceholder')}
        setIsOpen={setProtocolIsOpen}
        disabled={submitting || !selectedCryptocurrency}
      />
      <DropdownList isOpen={protocolIsOpen}>
        {selectedCryptocurrency
          ? selectedCryptocurrency.protocols.map((protocol) => (
            <DropdownItem
              key={protocol.code}
              disabled={submitting}
              dataTestName="protocol"
              handleClick={() => onProtocolSelect(protocol)}
              option={{
                value: protocol.code,
                text: protocol.name,
                icon: protocol.icon,
              }}
            />
          ))
          : null}
      </DropdownList>
    </DropdownSelect>
  </>
);

const DropdownList = styled.ul`
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
  z-index: 10;
  overflow: hidden;
  transform: scaleY(${props => (props.isOpen ? 1 : 0)});
  transform-origin: top;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
`;

const InvisibleInputForTests = styled.input`
    display: none;
`;

export default ProtocolDropdown;
